var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 55.5902099609375,
    height: 50.9329833984375,
    viewBox: "0 0 55.5902099609375 50.9329833984375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1_545"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D34",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#841600",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.9116,2.34695Q17.3825,3.87605,16.8497,5.81781L9.21951,5.81781Q5.40067,5.81781,2.70033,8.51814Q0,11.2185,0,15.0373L0,41.7135Q0,45.5323,2.70033,48.2327Q5.40067,50.933,9.21951,50.933L29.806,50.933Q33.6249,50.933,36.3252,48.2327Q37.7321,46.8257,38.406,45.1152L46.3707,45.1152Q50.1896,45.1152,52.8899,42.4149Q55.5902,39.7145,55.5902,35.8957L55.5902,9.66136L55.5902,8.60905Q55.5902,5.04306,53.0687,2.52153Q50.5472,0,46.9812,0L24.5777,0Q21.2586,0,18.9116,2.34695ZM30.4165,5.81781L21.457,5.81781Q22.3035,4.39024,24.5777,4.39024L46.9812,4.39024Q51.2,4.39024,51.2,8.60906L51.2,9.66137L51.2,35.8957Q51.2,40.7249,46.3707,40.7249L39.0255,40.7249L39.0255,38.7983Q41.9653,37.9573,44.3033,35.6991Q47.2382,32.8644,47.8808,29.1027L49.3789,29.1027C50.1242,29.1027,50.5417,28.2731,50.0813,27.7071L46.5948,23.421C46.2372,22.9814,45.5477,22.9814,45.1901,23.421L41.7036,27.7071C41.2432,28.2731,41.6607,29.1027,42.4059,29.1027L43.375,29.1027Q42.8253,31.023,41.2533,32.5413Q40.2294,33.5302,39.0255,34.1058L39.0255,17.7669Q40.2612,18.7051,41.0661,20.0487C41.4626,20.7106,42.1775,21.1157,42.9492,21.1157C44.1615,21.1157,45.1443,20.133,45.1443,18.9206C45.1443,18.5233,45.0364,18.1334,44.8322,17.7926Q43.1445,14.9751,40.2494,13.327Q39.5646,12.9372,38.8539,12.6372Q38.3677,10.203,36.504,8.33934Q33.9825,5.81781,30.4165,5.81781ZM33.8973,11.6359Q32.8708,10.2081,30.4165,10.2081L9.21951,10.2081Q4.39024,10.2081,4.39024,15.0373L4.39024,41.7135Q4.39024,46.5428,9.21951,46.5428L29.806,46.5428Q34.6353,46.5428,34.6353,41.7135L34.6353,16.0622Q34.2325,16.026,33.8187,16.026Q30.3394,16.026,27.89,18.3918Q26.2969,19.9304,25.7537,21.882L26.7907,21.882C27.536,21.882,27.9534,22.7116,27.493,23.2777L24.0065,27.5637C23.6489,28.0034,22.9595,28.0034,22.6019,27.5637L19.1154,23.2777C18.6549,22.7116,19.0724,21.882,19.8177,21.882L21.2538,21.882Q21.8849,18.0881,24.84,15.2339Q28.5654,11.6357,33.8187,11.6357Q33.8581,11.6357,33.8973,11.6359Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1_545)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt3);
export default __webpack_public_path__ + "static/media/opt3.538586ed8f52bf67a722c078ce36415f.svg";
export { ForwardRef as ReactComponent };